import { PF_HH, PF_HW } from '../constants';
import type { World } from '../World';

/**
 * Générateur de charge — ce n'est PAS du game design.
 *
 * Il maintient `spawn.targetEnemies` ennemis en vie pour que le socle puisse
 * être poussé à 200 ennemis et 2 000 projectiles, et mesuré contre son critère
 * (p99 < 14 ms). Le peuplement réel du jeu vient du `levelSystem` et de la
 * timeline de contenu depuis le J4.
 *
 * Il tire ses archétypes du catalogue injecté : ajouter un ennemi le fait
 * entrer automatiquement dans le banc de charge, sans qu'on ait à y penser.
 */
const LANES = 7;

export function spawnSystem(w: World): void {
  const target = w.spawn.targetEnemies;
  if (target <= 0) return;

  const defs = w.defs.enemies;
  if (defs.length === 0) return;

  let deficit = target - w.enemies.count;
  if (deficit <= 0) return;
  // Borné par tick : réapprovisionner 200 ennemis d'un coup produirait un pic
  // de temps de frame qui fausserait précisément la mesure qu'on cherche.
  if (deficit > 4) deficit = 4;

  for (let k = 0; k < deficit; k++) {
    const idx = w.rng.int(defs.length);
    const def = defs[idx]!;

    // Couloirs 1..LANES-2 : on exclut 0 et LANES-1, les pièges de bord.
    const lane = 1 + w.rng.int(LANES - 2);
    const x = -PF_HW + ((lane + 0.5) * (PF_HW * 2)) / LANES;

    const slot = w.enemies.spawn(
      idx,
      x,
      PF_HH + 60 + w.rng.range(0, 120),
      def.hp,
      def.visualRadius * 1.2,
      def.score,
      def.emitter.firstDelay,
      def.telegraph,
    );
    if (slot < 0) {
      w.overflow.enemies++;
      break;
    }
  }
}
